var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "preview-svg",
    d: "M24.136 8c.124 0 .238.042.331.113l.066.058 4.302 4.481a.59.59 0 0 1 .156.319l.008.089.001.006v18.702c0 .637-.467 1.162-1.062 1.226l-.121.006H12.183c-.611 0-1.116-.486-1.177-1.106L11 31.768V9.232c0-.637.467-1.162 1.062-1.226L12.183 8h11.953zm-.562 1.17h-11.39a.059.059 0 0 0-.052.031l-.008.031v22.536c0 .022.012.042.03.053l.03.008h15.633c.022 0 .04-.012.05-.03l.009-.031V13.65h-3.12c-.61 0-1.116-.485-1.176-1.106l-.006-.126V9.171zM20 26.606c.31 0 .562.262.562.585a.574.574 0 0 1-.562.586h-4.974a.574.574 0 0 1-.562-.586c0-.323.252-.585.562-.585zm-4.974-3.532h9.948c.31 0 .562.262.562.585a.579.579 0 0 1-.47.578l-.092.008h-9.948a.574.574 0 0 1-.562-.586c0-.29.204-.532.47-.578l.092-.007h9.948zm9.948-3.532c.31 0 .562.262.562.585 0 .291-.204.532-.47.578l-.092.007h-9.948a.574.574 0 0 1-.562-.585c0-.29.204-.532.47-.578l.092-.007h9.948zm0-3.532c.31 0 .562.262.562.585 0 .29-.204.532-.47.578l-.092.007h-9.948a.574.574 0 0 1-.562-.585c0-.291.204-.532.47-.578l.092-.007h9.948zm-.276-6.01v2.42c0 .023.011.043.029.053l.03.009h2.324l-2.383-2.482z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "preview-svg-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#preview-svg"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#preview-svg"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#preview-svg-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.1183dd9cbfa87c1cca9b8b12d13f35a8.svg";
export { ForwardRef as ReactComponent };